import AppWrapper, { appWrapper, launchApp } from "./appWrapper";
import ReactDOM from "react-dom";

const MOUNT_NODE = document.getElementById("app");

const render = (NextApp, messages, injectedStore) => {
  ReactDOM.render(appWrapper(NextApp, messages, injectedStore), MOUNT_NODE);
};

launchApp(render);
